import { Image } from '@graphcommerce/image'
import { useState } from 'react'
import { CategoryPageQuery } from '../../graphql/CategoryPage.gql'
import { RichTextBox } from '../RichText/RichTextBox'

interface CategoryExtraDescriptionProps {
  category: NonNullable<NonNullable<CategoryPageQuery['categories']>['items']>[number]
}

export function CategoryExtraDescription(props: CategoryExtraDescriptionProps) {
  const [isExpanded, setIsExpanded] = useState(false)
  const { category } = props
  return (
    <div className='mx-0 mt-[40px] rounded-[24px] bg-[#F8FBFF] px-5 md:mx-[10%] md:px-20 md:py-10'>
      <div className='grid grid-cols-1 gap-x-[70px] md:grid-cols-[40fr_60fr]'>
        {/* <Image
          src={category?.extra_image ?? category?.image ?? ''}
          alt={category?.image_alt ?? ''}
          unoptimized
          layout='fill'
          className='aspec-[4/3] relative aspect-auto h-[300px] w-[400px] rounded-[24px] object-cover'
        /> */}
        <div className='block aspect-[4/3]  h-auto w-full items-center justify-center overflow-hidden rounded-[24px] align-middle'>
          <Image
            src={category?.extra_image ?? category?.image ?? ''}
            alt={category?.image_alt ?? ''}
            className='h-full w-full object-cover object-center'
            sx={{
              height: '100%',
              aspectRatio: '4/3',
            }}
            unoptimized
            layout='fill'
          />
        </div>
        <div className='flex flex-col items-start justify-center pb-5'>
          <div className='relative'>
            <h3>
              <div
                className={`overflow-hidden transition-all duration-500 ease-in-out ${
                  isExpanded ? 'max-h-[1000px]' : 'max-h-64'
                }`}
              >
                <RichTextBox htmlContent={category?.extra_description} />
              </div>

              {/* Fade overlay when collapsed */}
              <div
                className={`pointer-events-none absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-[#F8FBFF] to-transparent transition-opacity duration-1000 ${
                  isExpanded ? 'opacity-0 delay-500' : 'opacity-100 delay-300'
                }`}
              />
            </h3>
          </div>
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            type='button'
            className='mt-4 cursor-pointer border-none bg-transparent p-0 font-semibold text-bright-templi-purple hover:text-bright-templi-purple-hover focus:outline-none'
          >
            {isExpanded ? 'Read Less' : 'Read More'}
          </button>
        </div>
      </div>
    </div>
  )
}
